import React, { PropTypes } from 'react';
import idx from 'idx';
import partial from 'lodash/partial';
import classnames from 'classnames';

const MAP = {
  image: ["grid", "list"],
  name: ["list", "dense"]
};

const CLASSES_MAP = {
  grid: "btn btn-sm fa fa-th-large",
  list: "btn btn-sm fa fa-bars",
  dense: "btn btn-sm fa fa-list"
};

export const getDefaultViewType = (entryType) => idx(MAP, _ => _[entryType][0]);

const ViewTypeSelector = ({ viewType, entryType, onChange }) => {
  const options = idx(MAP, _ => _[entryType]);

  if (!options) {
    return null;
  }

  return (
    <div className="controls-group">
      <h5 className="filter-name">View</h5>
      <div className="view-mode">
        { options.map((opt, i) => (
        <button key={i} className={classnames(CLASSES_MAP[opt], { selected: opt === viewType })}
          onClick={partial(onChange, opt)} />
        )) }
      </div>
    </div>
  );
}

ViewTypeSelector.propTypes = {
  viewType: PropTypes.string,
  entryType: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ViewTypeSelector;



// WEBPACK FOOTER //
// ./common/components/entry_gallery/view_type_selector.jsx